import React, { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import profile_img from "../../assets/images/profile_img.svg";
import ic_away from "../../assets/images/chat/ic_away.svg";
import { Dropdown } from "react-bootstrap";
import bx_phone_call from "../../assets/images/chat/bx_phone_call.svg";
import { AppContext } from "../../context/AppContext";
import more_vertical from "../../assets/images/chat/B_more_three.svg";
import more_blue from "../../assets/images/chat/more_vertical.svg";
import fileImg1 from "../../assets/images/chat/fileImg1.svg";
import fileImg12 from "../../assets/images/chat/fileImg12.svg";
import fileImg3 from "../../assets/images/chat/fileImg3.svg";
import fileImg4 from "../../assets/images/chat/fileImg4.svg";
import { ShareSocial } from "react-share-social";
import { getWithAuthCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig, { BASE_URL_CHAT_Image } from "../../api/ApiConfig";
const Files = ({ handleClose }) => {
  const [filesList, setFilesList] = useState([]);
  const { sidebar, currentSChannel } = useContext(AppContext);
  const [currentFiles, setCurrentFiles] = useState(null);
  const [share, setShare] = useState(false);

  const [currentList, setCurrentList] = useState([])

  const [currentTab, setCurrentTab] = useState('Media')



  const getFilterOut = () => {

    let fls = []

    if (currentTab === "Media") {
      fls = filesList?.filter((file) => {

        return file?.mimeType?.includes('image')

      })
    }

  }

  useEffect(() => {
    getFilterOut()
  }, [currentTab])



  useEffect(() => {
    getFiles();
  }, []);
  const getFiles = () => {



    getWithAuthCallWithErrorResponse(
      ApiConfig.GET_FILES + currentSChannel
    ).then((res) => {
      console.log(res);
      if (res.json.success) {
        setFilesList(res.json.data);


        setCurrentTab('Media')
      }
    });
  };

  function download(url, name, e) {
    e.preventDefault();
    fetch(url, {
      method: "GET",
      responseType: "blob",
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
      });
  }

  return (
    <>
      <div className="main_file_body" onClick={() => share && setShare(false)}>
        <div className="d-flex justify-content-around mt-2">
          <h6 onClick={() => handleClose(false)}>Chat</h6>
          <h6 className={currentTab === 'Media' ? "activeColorBlue" : ""}
            onClick={() => setCurrentTab('Media')}
          >Media</h6>
          <h6 className={currentTab === 'Docs' ? "activeColorBlue" : ""}
            onClick={() => setCurrentTab('Docs')}
          >Docs</h6>
          <h6 className={currentTab === 'Links' ? "activeColorBlue" : ""}
            onClick={() => setCurrentTab('Links')}
          >Links</h6>
        </div>
        <div style={{ height: '75vh', overflow: 'scroll' }}>
          {
            filesList?.length > 0 ? (
              (() => {
                const filteredFiles = filesList.filter((file) => {
                  if (currentTab === "Media") {
                    return file?.mimeType?.includes("image");
                  }
                  if (currentTab === "Docs") {
                    return file?.mimeType?.includes("application");
                  }
                  return false;
                });

                return filteredFiles?.length > 0 ? (
                  filteredFiles.map((file) => {
                    let path = file?.Resource_Path;
                    let parts = path?.split("/") || "";
                    let fileName = parts[parts?.length - 1] || '';

                    return (
                      <div className="single_Card_File" key={file.Resource_Id}>
                        {currentTab === "Media" && (
                          <div className="img_file">
                            <img src={path} alt="" />
                          </div>
                        )}

                        <div className="file_contain">
                          <div className="left">
                            <p className="name">{fileName}</p>
                            <p className="date">{file?.tm[0]?.CreatedOn?.split('T')[0] + " " + file?.tm[0]?.CreatedOn?.split('T')[1]}</p>
                          </div>

                          <div className="right">
                            <Dropdown className="ActionDropdown right-icon-chat">
                              <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                                className="ActionToggle"
                              >
                                <img src={more_vertical} alt="" />
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                className="ActionMenu"
                                onClick={() => setCurrentFiles(path)}
                              >
                                <ul className="actionnmenulist">
                                  <li>
                                    <a href={path} target="_blank" rel="noreferrer">
                                      Open
                                    </a>
                                  </li>

                                  <li>
                                    <a
                                      href="#"
                                      onClick={(e) => download(path, fileName, e)}
                                    >
                                      Download
                                    </a>
                                  </li>

                                  <li onClick={() => setShare(true)}>Share</li>

                                  <li
                                    onClick={() => {
                                      navigator.clipboard.writeText(path);
                                    }}
                                  >
                                    Copy Link
                                  </li>
                                </ul>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p>No files found</p>
                );
              })()
            ) : (
              <p>No files found</p>
            )
          }

          {share && (
            <ShareSocial
              url={currentFiles}
              socialTypes={["facebook", "twitter", "reddit", "linkedin"]}
              onSocialButtonClicked={(data) => console.log(data)}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Files;
